var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-control-pages-template-id-wrapper" },
    [
      _setup.options && (_setup.betaMode || !_vm.currentData.templateId)
        ? _c(_setup.FormControlTypeSelect, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
              options: _setup.options,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentData.templateId
        ? _c(_setup.PageContentTemplateContent, {
            attrs: {
              "form-id": _vm.formId,
              "template-id": _vm.currentData.templateId,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.pageId
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c(_setup.PageContentMobile, {
                attrs: {
                  "page-id": _setup.pageId,
                  "hide-modal": _setup.handleHideModalPlaceholder,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }